module.exports = __webpack_public_path__ + "static/media/accessory19.5ce595e8.webp";